const Card = ({suit, rank}) => {
	return (
		<div className={'card ' + suit}>
			{rankMap.get(rank)}{suitMap.get(suit)}
		</div>
	);
};

const rankMap = new Map<string, string>([
  ['ACE', 'A'],
  ['TWO', '2'],
  ['THREE', '3'],
  ['FOUR', '4'],
  ['FIVE', '5'],
  ['SIX', '6'],
  ['SEVEN', '7'],
  ['EIGHT', '8'],
  ['NINE', '9'],
  ['TEN', '10'],
  ['JACK', 'J'],
  ['QUEEN', 'Q'],
  ['KING', 'K'],
]);

const suitMap = new Map<string, string>([
  ['HEARTS', '♥'],
  ['DIAMONDS', '♦'],
  ['CLUBS', '♣'],
  ['SPADES', '♠'],
]);

export default Card;